<template>
	<el-dialog title="报验记录汇总" :close-on-click-modal="false" :visible.sync="subVisible" width="600px">
		<el-checkbox-group v-model="checkedValues">
			<el-row>
				<el-col :span="6" v-for="(item, index) in conclusionList" :key="index">
					<el-checkbox :label="item.displayValue">{{ item.displayName }}</el-checkbox>
				</el-col>
			</el-row>
		</el-checkbox-group>
		<div class="dialog-divider"></div>
		<el-row class="formBtnGroup" style="padding-top: 15px;">
			<el-col :span="24">
				<el-button class="btn" type="primary" size="small" @click="dataSubmit()"
					:disabled="disabledSaved">确定</el-button>
			</el-col>
		</el-row>
	</el-dialog>
</template>

<script>
import $common from "@/utils/common.js"
export default {
	name: "choose-progress-record",
	data() {
		return {
			subVisible: false,
			tableSelVals: [],
			dataList: [],
			dataForm: {
				recNo: '',
				monthlyRecNo: '',
			},
			conclusionList: [],
			checkedValues: [],
			conclusion: '',
			monthlyRecNo: '',
			descRecNo: '',
		};
	},
	methods: {
		init(monthlyRecNo, descRecNo) {
			this.monthlyRecNo = monthlyRecNo
			this.descRecNo = descRecNo
			this.dataForm = {
				recNo: '',
			}
			this.checkedValues = []
			this.conclusion = ''
			this.getInspectionConclusion()
			this.$nextTick(() => {
				this.subVisible = true;
			})
		},
		//获取报验结论
		getInspectionConclusion() {
			this.$http({
				url: this.$store.state.httpUrl + "/common/getInspectionConclusion",
				method: "get",
				params: {},
			}).then(({
				data
			}) => {
				if (data && data.resultCode === 200) {
					this.conclusionList = data.body
					const defaultItem = data.body.find(item => item.displayName === '接受')
					if (defaultItem) {
						this.checkedValues = [defaultItem.displayValue]
					}
				}
			});
		},
		dataSubmit() {
			this.conclusion = this.checkedValues.join(',')
			let _url = "/business/projectmonthlyreportfile/updateQualityVisa";
			this.$http({
				url: this.$store.state.httpUrl + _url,
				method: "post",
				data: this.$http.adornData({
					monthlyRecNo: this.monthlyRecNo,
					recNo: this.descRecNo,
					conclusion: this.conclusion
				})
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.$message({
						message: "操作成功",
						type: "success",
						duration: 1500,
						onClose: () => {
							this.subVisible = false;
							this.$emit("refreshDataList");
						}
					});
				}
			});
		},
	}
};
</script>

<style scoped="scoped">
.kind_row {
	background-color: rgb(243, 247, 247);
	padding: 10px 0 10px 15px;
	margin-bottom: 10px;
	margin-top: -8px;
}

.kind_label {
	color: black !important;
	font-weight: bold !important;
}

.kind_value_left {
	color: #3471b6 !important;
	font-weight: bold !important;
	margin-left: 10px;
}

/* 👇 核心修复：关闭按钮 绝对定位固定在弹窗顶部右上角 */
::v-deep .el-dialog__header {
  position: relative; /* 关键：让关闭按钮以头部为基准 */
  height: 50px !important;
  display: flex !important;
  align-items: center !important;
  padding: 0px !important;
  margin: 0 !important;
  background: #fff;
  border-bottom: 1px solid #e8e8e8;
}

::v-deep .el-dialog__title {
  line-height: 1 !important;
  font-size: 14px;
}

.dialog-divider {
	margin: 20px -20px 10px -20px;
	border-top: 1px solid #e8e8e8;
}

/* 👇 强制固定在顶部，永不乱跑 */
::v-deep .el-dialog__headerbtn {
  position: absolute !important;
  top: 15px !important;
  right: 15px !important;
  transform: none !important;
  margin: 0 !important;
}
</style>